import {isObject} from './functions';
import kafka_env from "./kafka_env";

export function sendDataToKafka(dataToSend) {
    const hasCorrectFormat = Array.isArray(dataToSend) && dataToSend.length;
    if (!hasCorrectFormat) {
        return;
    }

    const prefix = (location.hostname.split('.').length > 2 && location.hostname.split('.')[0].includes('stage'))
        ? `${location.hostname.split('.')[0]}_newclassics_`
        : 'newclassics_'
    ;

    try {
        dataToSend.forEach((queue) => {
            let kafkaDataFormat = {records: []};
            let topicName = queue.type;

            let queueData = queue.data;
            let fixedData = [];
            let _data = [];

            queueData.forEach((item) => {
                isObject(item) ? fixedData.push(Object.values(item)) : fixedData.push(item);
            });
            queueData = fixedData;

            //needed for different queue names for Kafka
            switch (topicName) {
                // page_load|page_advance|ads_loaded events have test cases when timestamps are in ms
                case 'page_load':
                    queueData.splice(5, 2);
                    break;
                case 'page_advance':
                    queueData.splice(1, 1);
                    break;
                case 'ads_loaded':
                    _data = queueData;
                    queueData = [];

                    _data.forEach(_d => {
                        _d.splice(2,1);
                        queueData.push(_d);
                    });
                    break;
                case 'session_start':
                    queueData[1] = queueData[1] * 1000;
                    topicName = 'session';
                    break;
                case 'user_answer':
                    queueData.splice(0,2)
                    queueData.splice(queueData.length - 2,1)
                    topicName = 'answers';
                    break;
                case 'user_result':
                    queueData.splice(0,1)
                    topicName = 'results';
                    break;
                case 'bids_collected':
                    _data = queueData;
                    queueData = [];

                    _data.forEach(_d => {
                        _d.splice(6,1);
                        queueData.push(_d);
                    });

                    topicName = 'prebid';
                    break;
                case 'taboola_spend':
                    queueData.splice(0,1)
                    break;
            }
            topicName = topicName.replaceAll('-', '_');
            topicName = `${prefix}${topicName}`;

            kafkaDataFormat.records.push({
                'key': topicName,
                'value': queueData
            });

            const kafkaUrl = (location.hostname.split('.').length > 2)
                ? `${kafka_env.url}`.replace('{env}', 'stage-')
                : `${kafka_env.url}`.replace('{env}', '')
            ;
            const serverUri = `${kafkaUrl}topics/${topicName}`;
            fetch(serverUri, {
                method: "POST",
                headers: {'Content-Type': 'application/vnd.kafka.json.v2+json'},
                body: JSON.stringify(kafkaDataFormat)
            });
        });
    } catch (error) {
        console.log('Kafka:' + error);
    }
}